"use client";

import { cn } from "@jesus-central-church/shared";
import {
  LazyCircularTestimonyCarousel,
  LazyTestimonyCarousel,
} from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbTestimonyCarousel } from "@storyblok/types/287435740670216/storyblok-components";

export function TestimonyCarouselComponent({
  blok,
}: {
  blok: SbTestimonyCarousel;
}) {
  const mappedTestimonials =
    blok.testimonials?.map((testimonial) => ({
      name: testimonial.name,
      designation: testimonial.designation,
      quote: testimonial.quote,
      image: testimonial.image.filename,
      alt: testimonial.image.alt,
    })) ?? [];

  // Lazy-loaded carousels - loads only when component renders (below the fold)
  // Per Vercel Best Practices: bundle-dynamic-imports
  if (blok.circular) {
    return (
      <LazyCircularTestimonyCarousel
        {...storyblokEditable(blok as SbBlokData)}
        title={blok.title}
        testimonials={mappedTestimonials}
        autoplay={blok?.autplay ?? false}
        textColorClasses={cn(`text-${blok.textColor as string}`)}
      />
    );
  }

  return (
    <LazyTestimonyCarousel
      {...storyblokEditable(blok as SbBlokData)}
      title={blok.title}
      testimonials={mappedTestimonials}
      autoplay={blok?.autplay ?? false}
      textColorClasses={cn(`text-${blok.textColor as string}`)}
    />
  );
}
